<template>
  <div class="address-input">
    <form-group
      :required="true"
      :errors="errors"
      :error-key="getErrorKey('address.text')"
      label="Dirección">
      <input
        id="patient-address"
        v-model="address.text"
        class="form-control"
        label="Dirección"
        maxlength="255"
        @input="handleAddressChange">
    </form-group>
    <div class="row">
      <form-group
        :required="true"
        :errors="errors"
        :error-key="getErrorKey('address.state')"
        label="Región"
        class="col-6">
        <el-select
          v-model="address.state"
          clearable
          filterable
          @input="handleAddressChange">
          <el-option
            v-for="region in regiones"
            :key="region"
            :value="region"
            :label="region" />
        </el-select>
      </form-group>
      <form-group
        label="Comuna"
        :required="true"
        :errors="errors"
        :error-key="getErrorKey('address.district')"
        class="col-6">
        <el-select
          v-model="address.district"
          clearable
          filterable
          @input="handleAddressChange">
          <el-option
            v-for="comuna in comunas"
            :key="comuna"
            :value="comuna"
            :label="comuna" />
        </el-select>
      </form-group>
    </div>
  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import RegionesComunas from '@/assets/data/regiones-comunas';

export default {
  name: 'AddressInput',
  components: {
    FormGroup
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    },
    errorsPrefix: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      address: JSON.parse(JSON.stringify(this.value)),
      regionesComunas: RegionesComunas
    };
  },
  computed: {
    regiones() {
      return this.regionesComunas.map(r => r.region);
    },
    comunas() {
      if (!this.address.state) return [];
      const comunas = this.regionesComunas.find(r => r.region === this.address.state);
      return comunas ? comunas.comunas : [];
    }
  },
  watch: {
    value(newValue) {
      if (this.address.text !== newValue.text) {
        this.address = JSON.parse(JSON.stringify(newValue));
      }
    }
  },
  methods: {
    getErrorKey(errorKey) {
      return this.errorsPrefix ? `${this.errorsPrefix}.${errorKey}` : errorKey;
    },
    handleAddressChange(value) {
      if (!this.address.state || this.value.state !== this.address.state) {
        this.address.district = '';
      }

      this.address.text = this.address.text.replace(/[^a-zA-Z0-9@ .ñáéíóúÁÉÍÓÚ\-\'\,]/g, '');
      this.$emit('input', JSON.parse(JSON.stringify(this.address)));
    }
  }
};
</script>

<style lang="scss">
/*Fixes double tap on iOS*/
.el-scrollbar__bar {
    opacity: 1!important;
}
</style>
